export default "__VITE_ASSET__B9YknUe8__"